import React from "react";
import "./Styles/card.css";

// Car images (replace with real cars later)
import car1 from "./assets/nassan.jpg";
import car2 from "./assets/jopp.jpg";
import car3 from "./assets/jeroo.jpg";
import car4 from "./assets/nassan.jpg";

const cars = [
  {
    id: 1,
    image: car1,
    name: "🚗 2013 Nissan Pathfinder S4WD",
    price: "$5,745",
    specs: "Engine:  3.5L V6 • Drive: Front Wheel Drive • Transmission: Automatic • Fuel: Gas • Interior: Black leather / 3rd Roll Seat",
  },
  {
    id: 2,
    image: car2,
    name: "🚗 2012 Jeep Wrangler Unlimited Sahara 4X4/rear wheel drive",
    price: "$8,600",
    specs: "Engine:  3.6L V6s • Drive: 4X4 / Rear Wheel Drive  • Fuel: Gas ⛽ • Transmission: Automatics • Interior: Brown leather",
  },
  {
    id: 3,
    image: car3,
    name: "🚗 2013 Dodge Journey SXT",
    price: "$4,200",
    specs: "Engine:  3.6L VVT • Drive: AWD, • Transmission: Automatic • Fuel: Gas ⛽ • Interior: Black non leather",
  },
  {
    id: 4,
    image: car4,
    name: "🚗 2013 Nissan Pathfinder S4WD",
    price: "$5,745",
    specs: "Engine:  3.5L V6 • Drive: Front Wheel Drive • Transmission: Automatic • Fuel: Gas • Interior: Black leather / 3rd Roll Seat",
  },
];

const CarCard = () => {
  const handleInquiry = (carName) => {
    alert(`Inquiry sent for ${carName}`);
  };

  return (
    <div className="card-container car-grid">

      {cars.map((car) => (
        <div className="card car-card" key={car.id}>

          <img src={car.image} alt={car.name} className="card-img" />

          <div className="car-body">
            <h3 className="card-title">{car.name}</h3>

            <p className="car-price">{car.price}</p>

            <p className="card-description">{car.specs}</p>

            <button
              className="inquiry-btn"
              onClick={() => handleInquiry(car.name)}
            >
              Make Inquiry
            </button>
          </div>

        </div>
      ))}

    </div>
  );
};

export default CarCard;